import React from "react";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
// import "leaflet/dist/leaflet.css";
// import { BrowserRouter } from "react-router-dom";

// Imports from the new file
import { client, refreshToken } from "./ApolloClient";

import ScrollToTop from "@/ui/ScrollToTop";
import AppRoutes from "@/routes/AppRoutes";
import { BrowserRouter as Router } from "react-router-dom";
import { UserByIdDocument } from "@/__generated__/graphql";
const theme = createTheme();

import "./index.css";

/** =========================
 * Init auth on load (safe)
 * ========================= */
const initializeAuth = async () => {
 const ok =  await refreshToken();
 if (!ok) return;
   // Re-sync the current user (esp. roles) so an existing session never
  // relies on a stale localStorage snapshot written at the last login.
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return;
    const { _id } = JSON.parse(raw);
    if (!_id) return;

    const { data } = await client.query({
      query: UserByIdDocument,
      variables: { id: _id },
      fetchPolicy: "network-only",
    });
    const freshUser = data?.userById;
    if (freshUser) {
      localStorage.setItem("userData", JSON.stringify(freshUser));
    }
  } catch {
    // Non-fatal: fall back to whatever is already stored.
  }
};


initializeAuth().finally(() => {
  const container = document.getElementById("root");
  if (!container)
    throw new Error("Root container with id 'root' was not found");

  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <ApolloProvider client={client}>
          <Router>
            <ScrollToTop />
            <AppRoutes />
          </Router>
        </ApolloProvider>
      </ThemeProvider>
    </React.StrictMode>,
  );
});
